const SELECTORS = {
  phoneNumber: "#main-loyalty #phoneNumber",
  otpNumber: "#main-loyalty #otpNumber",
  phoneError: ".phone-field-error",
  formPhone: "#main-loyalty #formPhone",
  formOtp: "#main-loyalty #formOtp",
  formNewCard: "#main-loyalty #formNewCard",
  cardPoints: ".cardPoints",
  newPoints: ".newPoints",
  accountExistsMessage: "#account-exists-message",
  cardNumber: ".cardNumber",
  email: "#email",
  firstName: "#main-loyalty #firstName",
  lastName: "#main-loyalty #lastName",
  date: "#main-loyalty #date",
  phone: "#main-loyalty #phone",
  termsAndConditions: "#main-loyalty #termsAndConditions",
  usedForPromotions: "#main-loyalty #usedForPromotions",
  usedForStatistics: "#main-loyalty #usedForStatistics",
  cardCreatedMessage: "#main-loyalty #card_created",
  loader: "#loader",
  loyaltyDetails: ".loyalty-details-container",
  loyaltyDescription: ".loyalty-description-container",
  cartDrawer: ".quick-cart",
  cart: ".cart-section",
  loyaltySection: ".section-loyalty",
  couponsContainer: ".coupons-container",
  couponsWrapper: ".coupons-wrapper",
  couponSuccessMessage: ".coupon-success-message",
  couponCode: ".coupon-code",
  loyaltyContainer: ".loyalty-container",
  resendOtp: "#resend-otp",
  countdown:"#main-loyalty #countdown",
  resendOtpButton: "#resend-otp-button",
  loyaltyNoCard: ".loyalty-no-card",
  otpError: ".otp-error",
  registrationError:".registration-error",
  phoneHidden: "#phone-hidden",
  resendOtpText: ".resend-otp-text",
  restartVerificationButton:" #restart-verification-button",
  submitOtpButton: "#submit-opt-button",
  termsAndConditionsError: ".terms-and-conditions-error",
  countryCode: "#countryCode",
  phoneVerificationError: ".phone-verification-error",
  loyaltyContent:".loyalty-content",
  confirmationMessage: ".confirmation-message",
  couponError: ".coupon-error-message",
  cardBlockedSection: ".loyalty-card-blocked",
  gender: "#gender",
  cardDeletedMessage: "#main-loyalty #card_deleted",
  complementaryImage:".complementary-image",
  cardImage:".card-image",
  couponsInformation: ".coupons-information",
};

const MESSAGES = {
  invalidPhoneNumber: window.loyaltyProgram?.errorMessages.invalidPhoneNumber,
  invalidOTPLength: window.loyaltyProgram?.errorMessages.invalidOTPLength,
  invalidOTP: window.loyaltyProgram?.errorMessages.invalidOTP,
  invalidEmail: window.loyaltyProgram?.errorMessages.invalidEmail,
  invalidFirstName: window.loyaltyProgram?.errorMessages.invalidFirstName,
  invalidLastName: window.loyaltyProgram?.errorMessages.invalidLastName,
  invalidDate: window.loyaltyProgram?.errorMessages.invalidDate,
  invalidAge: window.loyaltyProgram?.errorMessages.invalidAge,
  invalidPhone: window.loyaltyProgram?.errorMessages.invalidPhone,
  termsAndConditionsError: window.loyaltyProgram?.errorMessages.termsAndConditionsError,
  couponError: window.loyaltyProgram?.errorMessages.couponError,
  genericError: window.loyaltyProgram?.errorMessages.genericError,
  updateMetafieldError: window.loyaltyProgram?.errorMessages.updateMetafieldError
};

const CODES = {
  CellphoneOtpGenerateKeyX:"vR9HpAowTwPvhdn-q_2lQHv-0AWdO1zVHdARhi4PTJxiAzFudR5fbg==",
  CellphoneOtpVerifyKeyX:"kNnvYbYWNAWDeLQNyMrrhEkXsR-Ljyyv1-uI8hhkE-cMAzFu8LDhdg==",
  CreateCoupon:"RucsZcev347plU5pegMdEdpf0A1ubswHvvI_HJlZUa3jAzFudVjAkQ==",
  CreateNewCardKeyX:"C8OnCFygUbclid7QovnvkRNQRof7b5e0XDs-s9vyfsuzAzFuzxVPkA==",
  GetCustomerInfoKeyX:"Rj63GhFGly-0J6dCV8H9MwrodVsHC_yiNcbiaM2gj5lgAzFuWETseQ==",
  GetCustomerInfoKeyXById:"kLc_lK6H0u7XBOsNdJmxBc0d6GNT9yF7--oGkdIL2OWmAzFuLNuVyA==",
  GetDiscountsKeyX:"XziGzeYNGXYTA2i-UvrrjllipA7W8wtZHU4XJ1j4zFsIAzFupthmEA==",
  GetNCardKeyX:"55VcNbxYnDRFEtgVirczH5Rx20Jr9mzEzqTFs5Mx9xN5AzFucCkxLA==",
  GetProductPointsKeyX:"lUA-UH56kWIUUiQDQdOnZj9Pz9CJ1MUP7Km6rgunPbRTAzFusAbg7w==",
  SaveNCardKeyX:"xeTyENIeOewqBUuHgXb76K5MoPG_V4knepP5Yk8Uu2I4AzFu8o443Q=="
}
  


